<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="isAvailableToSave"
    :isCancel="!isAvailableToSave"
    @command="setCommand"
  >
    <form-editor
      :data="data"
      :model="formModel"
      @updateModelItem="handlerUpdateModelItem"
      @change="handleFormData"
      :isNew="!hasCreateNew"
      ref="Form"
    />
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        @command="setCommand"/>
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorContents',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Contents' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Contents/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: '',
        contentKey: '',
        html1: '',
        html2: '',
        html3: ''
      }
    }
  }
}
</script>
